import { logMessage } from './sentry';

const hexRegex = /^#(?:[0-9a-f]{3}){1,2}$/i;

export function hexToRGB(
  hex: string,
  outputArray: boolean = false
): string | number[] {
  hex = hex.trim();

  if (!hexRegex.test(hex)) {
    logMessage(`"${hex}" is not a valid hex color`);
    return '#ffffff';
  }

  let r: number, g: number, b: number;
  hex = hex.substring(1);
  if (hex.length === 3) {
    // shorthand hex color ex: #FFF
    [r, g, b] = [
      parseInt(`${hex[0]}${hex[0]}`, 16),
      parseInt(`${hex[1]}${hex[1]}`, 16),
      parseInt(`${hex[2]}${hex[2]}`, 16)
    ];
  } else {
    // longhand hex color ex: #FFFFFF
    [r, g, b] = [
      parseInt(`${hex[0]}${hex[1]}`, 16),
      parseInt(`${hex[2]}${hex[3]}`, 16),
      parseInt(`${hex[4]}${hex[5]}`, 16)
    ];
  }

  if (outputArray) {
    return [r, g, b];
  }

  return `rgb(${r},${g},${b})`;
}

// 0 < alpha < 1
export function hexToRGBA(
  hex: string,
  alpha: number = 1,
  outputArray: boolean = false
): string | number[] {
  hex = hex.trim();
  alpha = Math.min(Math.max(0, alpha), 1);

  if (!hexRegex.test(hex)) {
    logMessage(`"${hex}" is not a valid hex color`);
    return '#ffffff';
  }

  const rgbResult = hexToRGB(hex, true);
  const [r, g, b] = Array.isArray(rgbResult) ? rgbResult : [255, 255, 255];

  if (outputArray) {
    return [r, g, b, alpha];
  }

  return `rgba(${r},${g},${b},${alpha})`;
}

export function isHex(hex: string): boolean {
  return hexRegex.test(hex);
}

export function hexTo6digits(hex: string): string {
  if (!hexRegex.test(hex) || hex.length !== 4) {
    return hex;
  }

  const [, r, g, b] = hex.split('');

  return `#${r}${r}${g}${g}${b}${b}`;
}
